const headerDetail = {
  props: {
    dynamicClass: ".c-header-detail.dynamicLoading",
    cssSelector: "fastbookingEnable-JS",
    fastbookingSelector: "c-fastbooking",
    headSelector: ".c-header-detail[data-hotel-id]",
    parentSelector: ".web-inherited-reference",
    cssServiceSelector: "c-header-detail__header-back",
    readMore: ".read_more-JS",
    readLess: ".read_less-JS",
    shortText: ".short_text-JS",
    completeText: ".complete_text-JS",
    readMoreMeeting: ".read_more-meeting-JS",
    readLessMeeting: ".read_less-meeting-JS",
    shortTextMeeting: ".short_text-meeting-JS",
    completeTextMeeting: ".complete_text-meeting-JS",
    hidden: "hidden",
    cssSelectorSwiper: ".swiper-wrapper[data-items-load]",
    nameAttr: "data-items-load",
    classCompact: "mod--compact-carousel",
    paginationClassName: ".pagination-JS",
    numberPagination: 6,
    eventRoomIndexObject: { eventRoomList: [], currentEventRoomIndex: 0 },
    eventRoomModalButtonRight: ".eventRoomModalRowRightJS",
    eventRoomModalButtonLeft: ".eventRoomModalRowLeftJS",
    arrowRightRoomModalJS: ".arrowRightRoomModalJS",
    arrowLeftRoomModalJS: ".arrowLeftRoomModalJS",
    arrowRightRoomModalEnabledJS: false,
    arrowLeftRoomModalEnabledJS: false,
    modDisabled: "mod--disabled",
    modalFirstLoad: false,
    selectors: {
      newService: ".mod--new-services-JS",
      newMeeting: ".mod--new-meeting-JS",
    },
    classes: {
      newService: "mod--new-services",
      newMeeting: "mod--new-meeting",
    },
    config: {
      grabCursor: true,
      spaceBetween: 10,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      mousewheel: true,
      keyboard: true,
    },
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-headerDetail.css", this.props.dynamicClass);

    if (bcl.editMode) {
      return;
    }

    this.processUtagData();
    this.processFB();
    this.initNodeReadMore(this.props.readMore, this.props.readLess, this.props.shortText, this.props.completeText, this.eventMoreOrLess.bind(this));
    this.initNodeReadMore(this.props.readMoreMeeting, this.props.readLessMeeting, this.props.shortTextMeeting, this.props.completeTextMeeting, this.eventMoreOrLessMeeting.bind(this));
    bcl.u.swiper.init(document, this.props);
    if (bcl.u.mobile.isMobile()) {
      this.initPagination();
    }

    this.initEventRoomObject();
    if (document.querySelector(this.props.selectors.newService)) {
      document.body.classList.add(this.props.classes.newService);
    }
    if (document.querySelector(this.props.selectors.newMeeting)) {
      document.body.classList.add(this.props.classes.newMeeting);
    }
  },

  initEventRoomObject: function () {
    const allRoomsButtons = document.querySelectorAll(".buttonEventRoomMoreDetailsJS");
    if (allRoomsButtons) {
      bcl.u.forEach(allRoomsButtons, (obj) => {
        const eventRoomDataObject = { currentPosition: obj.dataset.eventroomposition, path: obj.dataset.href, pathAuthor: obj.dataset.urlAuthor, pathPublish: obj.dataset.urlPublish, htmlCached: "" };

        this.props.eventRoomIndexObject.eventRoomList.push(eventRoomDataObject);
      });
    }
  },

  initNodeReadMore: function (readMore, readLess, shortText, completeText, funct) {
    const nodeMore = document.querySelector(readMore);
    const nodeLess = document.querySelector(readLess);
    if (nodeMore && nodeLess) {
      funct(nodeMore, nodeLess);
    }
  },

  eventMoreOrLess: function (nodeMore, nodeLess) {
    nodeMore.addEventListener("click", () => {
      this.loadMore(false);
    });
    nodeLess.addEventListener("click", () => {
      this.loadLess(false);
    });
  },

  eventMoreOrLessMeeting: function (nodeMore, nodeLess) {
    nodeMore.addEventListener("click", () => {
      this.loadMore(true);
    });
    nodeLess.addEventListener("click", () => {
      this.loadLess(true);
    });
  },

  initPagination: function () {
    this.hideRooms();
    this.props.$pagination = document.querySelector(this.props.paginationClassName);
    this.props.$pagination &&
      this.props.$pagination.addEventListener("click", () => {
        this.paginationRooms();
      });
  },

  hideRooms: function () {
    const roomNodes = document.querySelectorAll(".c-meeting__table-table-row__container");
    bcl.u.forEach(roomNodes, (roomNode) => {
      if (bcl.u.containsClass(roomNode, "hidden-JS")) {
        bcl.u.addClass(roomNode, "hidden");
      }
    });
  },

  paginationRooms: function () {
    const roomNodes = document.querySelectorAll(".c-meeting__table-table-row__container.hidden-JS");
    for (let i = 0; i < roomNodes.length; i++) {
      bcl.u.removeClass(roomNodes[i], "hidden");
      bcl.u.removeClass(roomNodes[i], "hidden-JS");
    }
  },

  loadMore: function (isMeeting) {
    if (isMeeting) {
      const nodeMore = document.querySelector(this.props.readMoreMeeting);
      const nodeLess = document.querySelector(this.props.readLessMeeting);
      const nodeCompleteText = document.querySelector(this.props.completeTextMeeting);
      bcl.u.addClass(nodeMore, this.props.hidden);
      bcl.u.removeClass(nodeLess, this.props.hidden);
      bcl.u.removeClass(nodeCompleteText, this.props.hidden);
    } else {
      const nodeMore = isMeeting ? document.querySelector(this.props.readMoreMeeting) : document.querySelector(this.props.readMore);
      const nodeLess = isMeeting ? document.querySelector(this.props.readLessMeeting) : document.querySelector(this.props.readLess);
      const nodeShortText = isMeeting ? document.querySelector(this.props.shortTextMeeting) : document.querySelector(this.props.shortText);
      const nodeCompleteText = isMeeting ? document.querySelector(this.props.completeTextMeeting) : document.querySelector(this.props.completeText);
      bcl.u.addClass(nodeMore, this.props.hidden);
      bcl.u.addClass(nodeShortText, this.props.hidden);
      bcl.u.removeClass(nodeLess, this.props.hidden);
      bcl.u.removeClass(nodeCompleteText, this.props.hidden);
    }
  },

  loadLess: function (isMeeting) {
    if (isMeeting) {
      const nodeMore = document.querySelector(this.props.readMoreMeeting);
      const nodeLess = document.querySelector(this.props.readLessMeeting);
      const nodeShortText = document.querySelector(this.props.shortTextMeeting);
      const nodeCompleteText = document.querySelector(this.props.completeTextMeeting);
      bcl.u.addClass(nodeLess, this.props.hidden);
      bcl.u.addClass(nodeCompleteText, this.props.hidden);
      bcl.u.removeClass(nodeMore, this.props.hidden);
      bcl.u.removeClass(nodeShortText, this.props.hidden);
    } else {
      const nodeMore = isMeeting ? document.querySelector(this.props.readMoreMeeting) : document.querySelector(this.props.readMore);
      const nodeLess = isMeeting ? document.querySelector(this.props.readLessMeeting) : document.querySelector(this.props.readLess);
      const nodeShortText = isMeeting ? document.querySelector(this.props.shortTextMeeting) : document.querySelector(this.props.shortText);
      const nodeCompleteText = isMeeting ? document.querySelector(this.props.completeTextMeeting) : document.querySelector(this.props.completeText);
      bcl.u.addClass(nodeLess, this.props.hidden);
      bcl.u.addClass(nodeCompleteText, this.props.hidden);
      bcl.u.removeClass(nodeMore, this.props.hidden);
      bcl.u.removeClass(nodeShortText, this.props.hidden);
    }
  },

  processUtagData: function () {
    const headDom = document.querySelector(this.props.headSelector);

    if (headDom) {
      bcl.u.utag.enableListener(); // Open Listener to close with async call for price
      bcl.u.utag.add({ hotel_id: headDom.getAttribute("data-hotel-id") });
    }
  },

  processFB: function () {
    let element = document.getElementsByClassName(this.props.cssSelector),
      hiddeFB = null;

    if (!element || !element[0]) {
      return;
    }

    hiddeFB = element[0].dataset.hidefastbooking;

    this.props.$container = element[0];

    element = document.getElementsByClassName(this.props.fastbookingSelector);

    if (!element || !element[0]) {
      return;
    }

    const parent = element[0].closest(this.props.parentSelector);

    if (hiddeFB) {
      bcl.u.addClass(parent, "hidden");
    }

    this.props.$container.appendChild(parent);
  },
};

export default headerDetail;
